import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import Row from 'antd/lib/row'
import Col from 'antd/lib/col'
import Tooltip from 'antd/lib/tooltip'
import { CloseOutlined } from '@ant-design/icons'
import DiscountTabs from './DiscountTabs'
import Codes from './Codes'
import Loading from '../Utils/Loading'
import DiscountForm from './DiscountForm'
import { useGlobalQuery } from 'hooks/useGlobalQuery'
import { StyledDrawer } from 'components/Common'
import { DiscountType } from './types'

const Discounts = () => {
  const history = useHistory()
  const location = useLocation()
  const { isLoading } = useGlobalQuery()

  const [drawerVisible, setDrawerVisible] = useState(false)

  const setDrawerVisibility = (visible: boolean) => {
    setDrawerVisible(visible)
  }

  useEffect(() => {
    if (location.pathname === '/discounts') {
      history.replace('/discounts/manual')
    }
  }, [location.pathname, history])

  useEffect(() => {
    if (history.location.pathname.includes('discounts/code/edit'))
      return setDrawerVisible(true)
  }, [history.location.pathname])

  if (isLoading) return <Loading />

  return (
    <>
      <Row data-testid='discounts-component'>
        <Col span={24}>
          <DiscountTabs
            codes={<Codes type={DiscountType.MANUAL} />}
            automatic={<Codes type={DiscountType.AUTOMATIC} />}
            loyalty={<Codes type={DiscountType.LOYALTY} />}
          />
        </Col>
      </Row>
      <StyledDrawer
        open={drawerVisible}
        onClose={() => {
          setDrawerVisible(false)
          history.replace('/discounts/manual')
        }}
        width={720}
        title='Update Discount'
        data-testid='discounts-form'
        closeIcon={
          <Tooltip title={<span>Be sure to hit save! </span>}>
            <CloseOutlined className='close-icon' />
          </Tooltip>
        }
        className='discounts-drawer'
      >
        <DiscountForm setDrawerVisibility={setDrawerVisibility} />
      </StyledDrawer>
    </>
  )
}

export default Discounts
